import { capitalize } from "lodash";

export default {
  methods: {
    formatNumberK(value) {

      if(value){
        if (value >= 1000) {
          // Divide the value by 1000, round to two decimal places and append 'k'
          return (value / 1000).toFixed(2) + "k";
        }else{
          return value
        }
        
      }else{
        return value
      }
      
    },
    capitalizeString(str){
      return capitalize(str)
    },
    $formatAmount(value) {
        if(value){
          let val = parseFloat(value)
          return value > 0 ? val.toLocaleString('en-NG') : 0
        }
    },
    dateFormatter(rawdate) {
      let monthArray = [
        "Jan",
        "Feb",
        "Mar",
        "April",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec"
      ];
      let daysArray = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ];
      let sdate = new Date(rawdate);
      let sdatestring =
        daysArray[sdate.getUTCDay()] +
        " " +
        monthArray[sdate.getMonth()] +
        " " +
        sdate.getDate() +
        ", " +
        sdate.getFullYear();

      return sdatestring;
    },
    timeFormatter(rawdatetime) {
      // let monthArray = ["Jan", "Feb", "Mar", "April", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
      let sdate = new Date(rawdatetime);
      // let sdatestring =  monthArray[sdate.getMonth()] + ' ' + sdate.getDate() + ', ' + sdate.getFullYear();
      // this.scheduledate = sdatestring
      let stimestring =
        (sdate.getHours() < 12 ? sdate.getHours() : sdate.getHours() - 12) +
        ":" +
        (sdate.getMinutes() < 10
          ? `0${sdate.getMinutes()}`
          : sdate.getMinutes()) +
        (sdate.getHours() < 12 ? "am" : "pm");
      // this.scheduletime = stimestring;

      return stimestring;
    },
  }
};
